import { Button, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';

import './FeedbackButton.scss';

type FeedbackButtonProps = Readonly<{
    isError: boolean;
    onOpen: () => void;
}>;

export function FeedbackButton({ isError, onOpen }: FeedbackButtonProps) {
    const text = {
        error: 'Feedback is unavailable right now. Please try again later.',
        default: 'Help us improve your PetSmart experience.',
    };

    return (
        <div className={cn('feedback-button', { 'feedback-button--error': isError })}>
            <TextPassage className="feedback-button__text" size="lg">
                {isError ? text.error : text.default}
            </TextPassage>

            <Button text="Give feedback" disabled={isError} onClick={onOpen} />
        </div>
    );
}
